<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Debulha Data</mat-label>
                                <input matInput id="txtIniDebulhaData" #txtIniDebulhaData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Inicio_debulha_data" (blur)="makeCalculations()"
                                    (blur)="calcArmazemDias()" (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniDebulhaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_debulha_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Debulha Hora</mat-label>
                                <input matInput id="txtIniDebulhaHora" #txtIniDebulhaHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Inicio_debulha_hora"
                                    (blur)="makeCalculations()" (blur)="calcArmazemDias()" (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniDebulhaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_debulha_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Debulha Data</mat-label>
                                <input matInput id="txtFimDebulhaData" #txtFimDebulhaData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Termino_debulha_data"
                                    [dropSpecialCharacters]="false" (blur)="makeCalculations()"
                                    (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtFimDebulhaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_debulha_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Debulha Hora</mat-label>
                                <input matInput id="txtFimDebulhaHora" #txtFimDebulhaHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Termino_debulha_hora"
                                    (blur)="makeCalculations()" (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtFimDebulhaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_debulha_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Motivo Espera Debulha<span
                                        *ngIf="!readOnlyMtvEspDebulha" class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtMtvedeb formControlName="Motivo_espera_debulha" disableCenteringOption
                                    [class.InputBlockColor]="readOnlyMtvEspDebulha" [disabled]="readOnlyMtvEspDebulha"
                                    (selectionChange)="requiredSecagem()">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterMotvEspDebulha($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsMotvEspDebulha" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input matInput id="txtMtvedeb" #txtMtvedeb maxlength="50"
                                    formControlName="Motivo_espera_debulha" [readonly]="readOnlyMtvEspDebulha"
                                    [matAutocomplete]="auto1" [class.InputBlockColor]="readOnlyMtvEspDebulha">
                                <mat-autocomplete #auto1="matAutocomplete">
                                    <mat-option *ngFor="let item of filterOptionsMotvEspDebulha | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readOnlyMtvEspDebulha"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readOnlyMtvEspDebulha"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    Preencher apenas quando o Inicio Debulha
                                    - Termino Secagem ou Inicio Debulha - Termino Ressecagem for maior que 15h
                                </mat-hint>
                                <!-- <mat-hint align="end">{{txtMtvedeb.value.length}} / 50</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Motivo_espera_debulha)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md" >
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Mínima (%)</mat-label>
                                <input matInput id="txtUmidMin" #txtUmidMin maxlength="5"
                                    formControlName="Umidade_minima" currencyMask (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintNumber}} - "Peak Sample" OPTEK
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidMin.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_minima)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md" >
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Debulha Média (%)</mat-label>
                                <input matInput id="txtUmidDebMed" #txtUmidDebMed maxlength="5"
                                    formControlName="Umidade_debulha_media" currencyMask (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtUmidDebMed.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_debulha_media)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md" >
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Máxima (%)</mat-label>
                                <input matInput id="txtUmidMax" #txtUmidMax maxlength="5"
                                    formControlName="Umidade_maxima" currencyMask (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidMax.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_maxima)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md" >
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Desvio Padrão (%)</mat-label>
                                <input matInput id="txtDesvPadrao" #txtDesvPadrao maxlength="5"
                                    formControlName="Desvio_padrao" currencyMask (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDesvPadrao.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Desvio_padrao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira Topo Utilizada</mat-label>
                                <mat-select #txtLinDeb formControlName="Peneira_topo_utilizada" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterListPeneira($event.target.value)">
                                    <mat-option *ngFor="let item of listPeneiraTopo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido na Peneira Topo (%)</mat-label>
                                <input matInput id="txtRetPenT" #txtRetPenT maxlength="5"
                                    formControlName="Retido_na_peneira_topo" currencyMask (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtRetPenT.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Retido_na_peneira_topo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira Fundo Utilizada</mat-label>
                                <mat-select #txtLinDeb formControlName="Peneira_fundo_utilizada" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterListPeneiraFundo($event.target.value)">
                                    <mat-option *ngFor="let item of listPeneiraFundo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Vazado na Peneira Fundo (%)</mat-label>
                                <input matInput id="txtVazPenFun" #txtVazPenFun maxlength="5"
                                    formControlName="Vazado_na_peneira_fundo" currencyMask (blur)="requiredSecagem()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtVazPenFun.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Vazado_na_peneira_fundo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha da Debulha</mat-label>
                                <mat-select #txtLinDeb formControlName="Linha_da_debulha" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterLinDeb($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsLinDeb" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>